export default __webpack_public_path__ + "static/media/banner1.0dc65686.jpg";